import React from 'react';
import WaitingTimeSection from './WaitingTimeSection';
import { OPERATOR_STATUS } from 'UTILS/Constants';
import { getMessage } from "CONFIG/i18n";

const StatusLabel = (props) => {

  switch(props.operatorStatus) {
    case OPERATOR_STATUS.CALLING:
      if (props.isTransfer) {
        return (
          <button
            className={`status ${props.operatorStatus}`}
            disabled={false}
            onClick={props.startSession}
          >
            <div className="mainText">{getMessage('RESPOND_TRANSFER')}</div>
            <WaitingTimeSection 
              sessionCreatedTime={props.sessionCreatedTime}
            />
          </button>
        );
      } else {
        return (
          <button
            className={`status ${props.operatorStatus}`}
            disabled={false}
            onClick={props.startSession}
          >
            <div className="mainText">{getMessage('RESPOND')}</div>
            <WaitingTimeSection 
              sessionCreatedTime={props.sessionCreatedTime}
            />
          </button>
        );
      }
    case OPERATOR_STATUS.CORRESPONDENCE:
      return (
        <button
          className={`status ${props.operatorStatus}`}
          disabled={true}
        >
          <div className="mainText">{getMessage(props.operatorStatus)}</div>
        </button>
      );
    default:
      return (
        <button
          className={`status ${props.operatorStatus}`}
          disabled={true}
        >
          <div className="mainText">{getMessage(props.operatorStatus)}</div>
        </button>
      );
  }
};

export default StatusLabel;
